import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { OtpSessionDto } from '../../../domain/otp/otp';
import { RemoteResponse } from '../../../domain/infra/remote';
import { RemoteStatus } from '../../../domain/infra/remote';
import { ReservationDetailDto } from '../../../domain/reservation/reservationDto';
import { Action } from '../../../domain/infra/remote';
import { GhostComponent } from '../../../utils/ghostComponent';
import {RemoteInfoMedia} from '../../../domain/chargeRecord/remoteInfoChargeRecord';
import { IziviaLoggerService } from '../../../services/common/iziviaLogger.service';


@Component({
    selector: 'reservation-details',
    templateUrl: './reservationDetails.component.html',
    styleUrls: ['./reservationDetails.component.scss']
})
export class ReservationDetailsComponent extends GhostComponent implements OnChanges {
    @Input() reservationDetail: ReservationDetailDto;
    @Output() remoteDoneEvent: EventEmitter<RemoteResponse> = new EventEmitter();

    // dirty hack to enable type-safety to the view
    Action = Action;

    canShowRemoteStart: boolean;
    remoteStart: boolean;
    remoteRequest: RemoteInfoMedia;

    constructor(private readonly loggerService: IziviaLoggerService) {
        super();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.reservationDetail) {
            const reservationDetail: ReservationDetailDto = changes.reservationDetail.currentValue;
            this.canShowRemoteStart = !!reservationDetail
                && !!reservationDetail.remoteStart
                && (!!reservationDetail.otpCode || !!reservationDetail.mediaCode)
                && !!reservationDetail.infraChargeDto
                && !!reservationDetail.infraChargeDto.station
                && !!reservationDetail.infraChargeDto.station.id
                && !!reservationDetail.infraChargeDto.chargePoint
                && !!reservationDetail.infraChargeDto.chargePoint.id
                && !!reservationDetail.infraChargeDto.plug
                && !!reservationDetail.infraChargeDto.plug.id;
        }
    }

    showRemoteStart() {
        this.remoteStart = true;
        this.remoteRequest = new RemoteInfoMedia(this.reservationDetail.infraChargeDto.station.id,
            this.reservationDetail.infraChargeDto.chargePoint.id,
            this.reservationDetail.infraChargeDto.plug.id,
            this.reservationDetail.otpCode ?
                this.reservationDetail.otpCode : this.reservationDetail.mediaCode);
        this.remoteRequest.chargeAreaRef = this.reservationDetail.infraChargeDto.chargeArea.id;
    }

    handleRemoteResponse(remoteResponse: RemoteResponse) {
        if (remoteResponse?.status === RemoteStatus.DONE) {
            remoteResponse.otpSessionRef = this.reservationDetail.id;
            this.remoteDoneEvent.emit(remoteResponse);
        } else if (remoteResponse?.status === RemoteStatus.TIMEOUT) {
            this.loggerService.debug('[handleRemoteResponse] TIMOUT', remoteResponse);
            this.remoteDoneEvent.emit(remoteResponse);
        } else {
            this.remoteRequest = null;
        }
    }

    generateGhost(): void {
    }
}
